import { render } from "./AppointmentPage.vue?vue&type=template&id=a96237c6&scoped=true"
import script from "./AppointmentPage.vue?vue&type=script&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&lang=js"

import "./AppointmentPage.vue?vue&type=style&index=0&id=a96237c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96237c6"]])

export default __exports__